import Wix from '../services/wix-sdk-polyfill';

export const closeWixModal = action => () => {
  Wix.closeWindow(action);
};



// WEBPACK FOOTER //
// ./app/actions/close-wix-modal.js